var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradecredit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#ECEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.3263 20.9834C18.0036 20.9834 20.9846 18.0024 20.9846 14.3251C20.9846 10.6478 18.0036 7.66675 14.3263 7.66675C10.649 7.66675 7.66797 10.6478 7.66797 14.3251C7.66797 18.0024 10.649 20.9834 14.3263 20.9834Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3094 19.3249C24.3094 22.0749 22.076 24.3083 19.326 24.3083C17.626 24.3083 16.1344 23.4583 15.2344 22.1666C18.8677 21.7583 21.7594 18.8666 22.1677 15.2333C23.4594 16.1333 24.3094 17.6249 24.3094 19.3249Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.543 14.0917L13.543 13.3917C13.343 13.325 13.3013 13.3083 13.3013 13.0167C13.3013 12.8 13.4513 12.625 13.643 12.625H14.893C15.1596 12.625 15.3763 12.8667 15.3763 13.1667C15.3763 13.5083 15.6596 13.7917 16.0013 13.7917C16.343 13.7917 16.6263 13.5083 16.6263 13.1667C16.6263 12.2083 15.8846 11.425 14.9596 11.3833V11.3417C14.9596 11 14.6763 10.7167 14.3346 10.7167C13.993 10.7167 13.7096 10.9917 13.7096 11.3417V11.3833H13.6346C12.7596 11.3833 12.043 12.1167 12.043 13.025C12.043 13.8167 12.393 14.325 13.118 14.575L15.1263 15.275C15.3263 15.3417 15.368 15.3583 15.368 15.65C15.368 15.8667 15.218 16.0417 15.0263 16.0417H13.7763C13.5096 16.0417 13.293 15.8 13.293 15.5C13.293 15.1583 13.0096 14.875 12.668 14.875C12.3263 14.875 12.043 15.1583 12.043 15.5C12.043 16.4583 12.7846 17.2417 13.7096 17.2833V17.3333C13.7096 17.675 13.993 17.9583 14.3346 17.9583C14.6763 17.9583 14.9596 17.675 14.9596 17.3333V17.2917H15.0346C15.9096 17.2917 16.6263 16.5583 16.6263 15.65C16.6263 14.8583 16.268 14.35 15.543 14.0917Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradecredit);
export default __webpack_public_path__ + "static/media/tradecredit.d0d25e8208250c58c3db68ea34205439.svg";
export { ForwardRef as ReactComponent };